import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  WrapperElement,
} from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<WrapperElement>["defaultData"] = {
  attributes: {
    "background-repeat": "no-repeat",
    "background-size": "auto",
    "background-position": "top center",
    direction: "ltr",
    padding: "20px 0px",
    "padding-top": "20px",
    "padding-right": "0px",
    "padding-bottom": "20px",
    "padding-left": "0px",
    "text-align": "center",
  },
  data: {},
};

export const Wrapper = createBlock<WrapperElement>({
  get name() {
    return t("Wrapper");
  },
  defaultData,
  type: BasicType.WRAPPER,
  create: (payload) => {
    const defaultData: WrapperElement = {
      type: BasicType.WRAPPER,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.WRAPPER,
  render(params) {
    return <BasicBlock params={params} tag="mj-wrapper" />;
  },
});
